
export function HeroSection() {
  return (
    <section className="relative min-h-screen bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/banners/hero-region-africa.jpg')`
      }}>
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <div className="relative z-10 container mx-auto px-6 py-32 lg:py-40">
        <div className="max-w-4xl">
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Africa - Regional Discoveries
          </h1>
          <p className="text-xl lg:text-2xl text-emerald-400 mb-8 font-medium">
            Explore Africa With PrimeMeridian
          </p>
          <div className="prose prose-lg text-white max-w-none">
            <p className="text-lg leading-relaxed mb-6">
              Africa is a continent of infinite discovery, and beyond its well-trodden safari trails lie destinations that feel almost otherworldly in their beauty and authenticity. Along the Kenyan coast, the ancient island of Lamu enchants visitors with its Swahili charm—narrow, car-free streets, dhow boats drifting across the ocean, and centuries-old mosques that whisper tales of a rich cultural past.
            </p>
            <p className="text-lg leading-relaxed mb-6">
              Far to the southwest, the vast red dunes of Namibia stretch endlessly into the horizon, and within the exclusive NamibRand Nature Reserve, luxury desert lodges open onto landscapes where the silence is broken only by the wind, and nights unveil a sky so clear it feels infinite.
            </p>
            <p className="text-lg leading-relaxed">
              For those seeking islands untouched by time, São Tomé & Príncipe emerge from the Atlantic like a secret whispered only to a few. Rainforests, cocoa plantations, and volcanic peaks set the stage for barefoot luxury retreats where authenticity reigns.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
